import Vue from 'vue';
import VueRouter from 'vue-router';
import ui from '../ui';
import CInput from '../components/c-input';
import CBlockInput from '../components/c-block-input';
import CLoading from '../components/c-loading';
import CPicker from '../components/c-picker';
import CSpinner from '../components/c-spinner';
import CNav from '../components/c-nav.vue';
import env from '../utils/env';
import partner from '../partner/source';
import apiErrorHandler from '@/mixins/apiErrorHandler'

Vue.use(VueRouter);
Vue.use(NavigationBar);
Vue.use(ApiErrorHandler);

Vue.prototype.$updateTitle = function(title) {
    ui.updateTitle(title);

    if (this.$nav) {
        this.$nav.title = title;
    }
};

Vue.prototype.$showLoading = ui.showLoading;
Vue.prototype.$hideLoading = ui.hideLoading;
Vue.prototype.$withLoading = ui.withLoading;
Vue.prototype.$popup = ui.showPopup;
Vue.prototype.$notify = ui.showNotification;
Vue.prototype.$pick = ui.showPicker;
Vue.prototype.$select = ui.showOptions;

Vue.component('c-input', CInput);
Vue.component('c-block-input', CBlockInput);
Vue.component('c-loading', CLoading);
Vue.component('c-picker', CPicker);
Vue.component('c-spinner', CSpinner);

export default Vue;

function NavigationBar(Vue) {
    Vue.mixin({
        components: {
            CNav,
        },

        beforeCreate() {
            const parent = this.$parent;
            if (!parent) return;

            // 只在root的子节点添加_nav字段
            if (!parent.$parent) {
                const route = this.$route;
                const {
                    title
                } = route && route.meta || {};
                // TODO
                const nav = {
                    show: isNavShow(env), //env.isPartner, //是否展示顶部nav
                    showBack: true,
                    firstPageShowBack: env.isFirstPageNavBack, //第一页是否显示会退按钮
                    title: title || ''
                };
                Vue.util.defineReactive(this, '_nav', nav);
            } else if (parent._nav) {
                this._nav = parent._nav;
            }
        }
    });

    Object.defineProperty(Vue.prototype, '$nav', {
        get() {
            return this._nav;
        }
    });
}

// 默认不展示(微信端不展示, 微信小程序不展示，快应用不展示)，第三方渠道才展示，个别第三方渠道不展示
function isNavShow(env) {
    return !(env.isWeixin || env.isWeixinMiniProgram || env.isQuickApp) && env.isPartner && partner.noNav.indexOf(env.partner) === -1;
}

function ApiErrorHandler(Vue) {
    Vue.mixin({
        mixins: [apiErrorHandler]
    })
}



// WEBPACK FOOTER //
// ./src/app/vue.js